import styled, { css } from 'styled-components';

export const Separator = styled.div`
  height: 1px;
  width: 100%;
  background-color: ${({ theme }) => theme.kallisto.color.border.static.borderDisabled};
`;

/* The design system hardcodes size={22} as an SVG width/height attribute and margin-left on its
   own class, both of which these override. 20px matches the pill's left icon. */
export const evoPillMetrics = css`
  [class*='Pill__DeleteIcon'] {
    width: 20px;
    height: 20px;
    margin-left: 2px;
    color: ${({ theme }) => theme.kallisto.color.background.static.backgroundBrandPrimary};

    &:hover {
      color: ${({ theme }) => theme.kallisto.color.background.static.backgroundBrandPrimary};
    }
  }
`;

export const PillRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;

  ${evoPillMetrics}
`;
